import React from 'react'
import '../Styles/Section6.css'

export default function Section6() {
  return (
    <div className='section6'>
        <div className="digimage"></div>
        <div className="sec6container">
          <div className="sec6box">
            <i className="fa-solid fa-face-laugh-beam"></i>
            <p className="sec6head">500+</p>
            <p className="sec6para">Happy Students</p>
          </div>
          <div className="sec6box">
            <i className="fa-solid fa-street-view"></i>
            <p className="sec6head">100%</p>
            <p className="sec6para">Assured Placement</p>
          </div>
          <div className="sec6box">
            <i className="fa-solid fa-user-graduate"></i>
            <p className="sec6head">50+</p>
            <p className="sec6para">Faculty Members</p>
          </div>
          <div className="sec6box">
            <i className="fa-solid fa-briefcase"></i>
            <p className="sec6head">5+</p>
            <p className="sec6para">Programs Offered</p>
          </div>
        </div>
    </div>
  )
}
